module.exports = {
    save( key = false, data ) {
        if( !key ) return
        localStorage.setItem(key, JSON.stringify(data))
        return true
    },
    get( key = false) {
        if( !key ) return
        const data = localStorage.getItem( key )
        return JSON.parse(data);
    }
}